<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="CHAPTER1" id="uPVwsKdMUTDcQXoIU2kE6R4" lang="en-US"><span class="Basic_Bold"><a id="u2IlEUDoSDvlRZuIC4yLVB4"></a>Through the Looking Ass</span></p>
<p class="Perfect-Center" lang="en-US">“Why do you keep such ugly beasts?”</p>
<p class="Perfect-Center" lang="en-US">it’s often asked of me.</p>
<p class="Perfect-Center" lang="en-US">“Why not have one horse at least,</p>
<p class="Perfect-Center" lang="en-US">so beautiful, wild, and free?”</p>
<p class="Perfect-Center-2" lang="en-US">It seems so plain, so obvious,</p>
<p class="Perfect-Center" lang="en-US">how could I feel ill-fated?</p>
<p class="Perfect-Center" lang="en-US">To surround myself with the very best</p>
<p class="Perfect-Center" lang="en-US">that ever were created.</p>
<p class="Perfect-Center-2" lang="en-US">A friendship now days known by few,</p>
<p class="Perfect-Center" lang="en-US">the very best companions.</p>
<p class="Perfect-Center" lang="en-US">Contented just to pack us through</p>
<p class="Perfect-Center" lang="en-US">the mountains, plains, and canyons.</p>
<p class="Perfect-Center-2" lang="en-US">It seems forever, more or less,</p>
<p class="Perfect-Center" lang="en-US">he’s shouldered mankind’s loads</p>
<p class="Perfect-Center" lang="en-US">and brought us through the wilderness</p>
<p class="Perfect-Center" lang="en-US">with little use for roads.</p>
<p class="Perfect-Center-2" lang="en-US">And while I’m no religious man,</p>
<p class="Perfect-Center" lang="en-US">it must show good behavior</p>
<p class="Perfect-Center" lang="en-US">to be chosen as delivery van</p>
<p class="Perfect-Center" lang="en-US">and guardian of the savior.</p>
<p class="Perfect-Center-2" lang="en-US">He provides us with solutions</p>
<p class="Perfect-Center" lang="en-US">for problems yet uncounted,</p>
<p class="Perfect-Center" lang="en-US">but his greatest contributions</p>
<p class="Perfect-Center" lang="en-US">are not when he is mounted.</p>
<p class="Perfect-Center-2" lang="en-US">When you gaze upon a grazing jack,</p>
<p class="Perfect-Center" lang="en-US">you may see a lowly ass.</p>
<p class="Perfect-Center" lang="en-US">You can be sure he’s looking back</p>
<p class="Perfect-Center" lang="en-US">‘neath the guise of nibbling grass.</p>
<p class="Perfect-Center-2" lang="en-US">He wears the perfect poker face,</p>
<p class="Perfect-Center" lang="en-US">he is what you impose.</p>
<p class="Perfect-Center" lang="en-US">But while you stand there heels in place,</p>
<p class="Perfect-Center" lang="en-US">he’s always on his toes.</p>
<p class="Perfect-Center-2" lang="en-US">Unknowing eyes will think they feast</p>
<p class="Perfect-Center" lang="en-US">upon a silly creature.</p>
<p class="Perfect-Center" lang="en-US">A simple, strange, and awkward beast</p>
<p class="Perfect-Center" lang="en-US">without redeeming feature.</p>
<p class="Perfect-Center-2" lang="en-US">Those that are demanding</p>
<p class="Perfect-Center" lang="en-US">will find his every fault</p>
<p class="Perfect-Center" lang="en-US">and take each patient standing</p>
<p class="Perfect-Center" lang="en-US">as a personal assault.</p>
<p class="Perfect-Center-2" lang="en-US">If then they try to use some force</p>
<p class="Perfect-Center" lang="en-US">and find he can’t be budged.</p>
<p class="Perfect-Center" lang="en-US">He’s judged the wrong end of a horse,</p>
<p class="Perfect-Center" lang="en-US">themselves correctly judged.</p>
<p class="Perfect-Center-2" lang="en-US">But patient, understanding eyes</p>
<p class="Perfect-Center" lang="en-US">might find a lifelong friend,</p>
<p class="Perfect-Center" lang="en-US">one to trust when hard times rise,</p>
<p class="Perfect-Center" lang="en-US">one to count on to the end.</p>
<p class="Perfect-Center-2" lang="en-US">So, if you see a lowly ass,</p>
<p class="Perfect-Center" lang="en-US">then that’s just what he’ll be</p>
<p class="Perfect-Center" lang="en-US">when viewing nature’s looking glass,</p>
<p class="Perfect-Center _idGenParaOverride-1" lang="en-US">you are just what you see.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chap_01.vue?eb2e7740